import React from "react";

function SmokeSensorWidget() {

  return (
    <div className={`widget red`}>
      <div className="dashboard-widget-title">
        <h1 className="dashboard-widget-title-name">화재 감지 센서</h1>
        <p className="dashboard-widget-title-place">장소</p>
      </div>
      <div className="dashboard-widget-info">감지됨</div>
    </div>
  );
}

export default SmokeSensorWidget;
